import { IObjektVy } from '../../../../../Types/ObjektVy';
/* import ObjektVySida from '../../../_Common/Components/BusinessCollectionComponents/ObjectVySida';
import ObjektVyGrupp from '../../../_Common/Components/BusinessCollectionComponents/ObjectVyGrupp'; */
import { collectionCompToObjektVy } from '../../../_Common/Components/BusinessCollectionComponents/BusinessCollectionUtils';

/* const standard = ObjektVySida('standard', [
  [
    ObjektVyGrupp('id', [
      'MOMSKOD',
      'BENAMNING',
      'MOMS_SATS1',
      'MOMS_SATS2',
      'DATUMMOMSBYTE',
    ]),
  ],
]);
 */
const customView = () => {
  return (
    <div>
      <h2>Detta är min alternativa vy</h2>
    </div>
  );
};

const view = collectionCompToObjektVy(customView, 'myView');

export const MomsVyer: IObjektVy[] = [view];
